export const mapCategoriesResponse = (categories) => {
  if (!categories?.length) return [];

  return categories.map((item) => ({
    name: item.taxon.name
  }));
};
